import { SimpleObservable } from "./SimpleObservable";

export type OrderCartType = 'traveler' | 'approver' | 'expense-report' | 'advance';

export class OrderCartService extends SimpleObservable {
  private openCarts = new Set<OrderCartType>();

  public hasOpenCart(): boolean {
    return this.openCarts.size > 0;
  }

  public openCart(cartType: OrderCartType): void {
    this.openCarts.add(cartType);
    this.inform({ type: "open", data: cartType });
  }

  public closeCart(cartType: OrderCartType): void {
    this.openCarts.delete(cartType);
    this.inform({ type: "close", data: cartType });
  }

  public closeAllCarts(): void {
    this.openCarts.clear();
    this.inform({ type: "closeAll", data: null });
  }
}

export const orderCartService = new OrderCartService();
